
import { gsap } from 'gsap';
import { RoadRage } from '../../RoadRage';
import { FsLeftBox } from '../../background/FsLeftBox';
import { GameData, InitData } from '../../server/data/BaseModel';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { StateHandler } from "../../../dev/utils/StateHandler";
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { BonusCounters } from '../../independent/countup/BonusCounters';
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { CarMoveInfo, CarTypes } from '../../server/data/GameDataModels';
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { RoadRageSpriteSymbol } from "../../reel/symbol/RoadRageSpriteSymbol";
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { MathHelper } from '../../../dev/utils/MathHelper';
import { GameSetting } from '../../../dev/setting/GameSetting';

class SetupState extends StateHandler {
    public static ENTER: string = "enter";
    public static BOXES: string = "boxes";
    public static DRIVE: string = "drive";
    public static SWITCHLANE: string = "switchlane";
    public static APPLY: string = "apply";
    public static RESULT: string = "result";
    public static DONE: string = "done";
}

export class SetupFlow extends Presentation {

    /*
        F1: StopSign : Stops The Car. // Kills it on the spot.
        F2: SwitchLane-Sign: if possible.
        F3: U-Turn: Turn the car around for a new round.
        F4: Contruction-Sign: Random Feature
        F5: BirdShit: +1 FS. - Count up on 
        F6: RoadBump: +1 DriveBy on car. 
        F7: StoneShot: +1 Mult stack. 
    */

    protected gameData: GameData;
    protected state: SetupState = new SetupState();
    protected carInfo: CarMoveInfo[] = [];
    protected startFromRight: boolean = false;

    protected carStopped: string[] = [];

    protected endReel: number = 0;
    protected startReel: number = 0;
    protected stepDirection: number = 0;

    protected isRetrigged: boolean = false;

    protected isRestore: boolean = false;
    protected isRestoreAndValue: boolean = false;
    
    private birdHit:boolean = false;
    private movedOutSound:boolean = false;

    private birdCatcher:gsap.core.Timeline[] = [];
 
    setGamedData(data: GameData & InitData): void {
        this.isRestore = !!data.isRestoreState;
        this.gameData = data;

        this.startFromRight = data.Reel.isCarOnReel(4);

        this.carInfo = data.Reel.carMoveInfo;
        this.carInfo.forEach((c, i) => this.carInfo[i].reelTo = c.reel);

        this.startReel = (this.startFromRight ? 4 : 0);
        this.endReel = (this.startFromRight ? 0 : 4);

        this.stepDirection = (this.startFromRight ? -1 : 1);

        this.isRetrigged = RoadRageEngineManager.AllReels.findIndex(r => !r.isActive) >= 0;
        this.isRestoreAndValue = this.isRestore;
        this.carStopped = [];
    }

    preStart(): void {
        this.state.set(this.isRetrigged ? SetupState.DRIVE : SetupState.ENTER);
        RoadRageEngineManager.getReel(this.startFromRight ? 4 : 0).isActive = true;

        this.carInfo.sort((a,b) => {return a.row - b.row})

        if(this.gameData.Win.totalWin && this.isRestore) SlotGame.keypadPlugin.setWin(this.gameData.Win.totalWin, true, this.gameData.Win.isWinBelowStake());
    }

    createPresentation(enableSkip: Function) {
        
        switch (this.state.value) {
            case SetupState.ENTER:
                SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
                this.carEnters();
                this.state.set(SetupState.DRIVE);
                break;
            case SetupState.DRIVE:
                enableSkip(true);
                this.birdCatcher = [];
                this.birdHit = false;
                this.driveCars();
                this.driveCollect();
                this.state.set(SetupState.SWITCHLANE);
                break;
            case SetupState.SWITCHLANE:
                enableSkip(true);
                this.timeline.to(this,{duration: (this.trySwitchLane() ? 0.65 : GameSetting.isFastSpin ? 0 : 0.3) + (GameSetting.isFastSpin ? 0 : this.carInfo.length * 0.13) });
                this.state.set(SetupState.APPLY);
                break;
            case SetupState.APPLY:
                enableSkip(false);
                this.movedOutSound = false;
                this.stopOrTurn();
                break;
            case SetupState.RESULT:
                enableSkip(false);
                const durr: number = 0.5;

                if(this.gameData.nextMode != "FREESPIN_SETUP"){
                    FsLeftBox.instance.enable(false, durr);
                } 
                
                if (this.gameData.nextMode === GameMode.NORMAL) { // debugging
                    SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
                    RoadRageEngineManager.preferedLayoutSize = 3;
                }

                if(this.gameData.nextMode != "FREESPIN_SETUP")
                    this.timeline.to(this, { duration: durr * 0.5 })
                else this.timeline.to(this, { duration: durr * 0.5 })
                
                this.state.set(SetupState.DONE);
                break;
            default:
                this.PresentationState.setInactive();
        }

        if (this.timeline.totalDuration() > 0)
            this.timeline.to(this, { duration: 0.1 })
    }

    carEnters(): void {

        const duration: number = 0.5;

        if(!this.isRestore){ 
            RoadRageEngineManager.getReel(this.startReel).setupCarMovesIn(duration);
            SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_ENTER);
        }else
            RoadRage.backgroundElements.fadeInCloud();

        RoadRageEngineManager.getReel(this.startReel).AllWindowSymbols.forEach(s => {
            if(!s.gotMarked && !s.isCar){
                s.changeState({state:"Disabled", forceState:true, duration:0.5});
            }
        })

        Object.keys(this.gameData.fsInfo.fsCars).forEach( carKey => {
            this.timeline.add(RoadRage.bgOverlay.enableBox(carKey,true, !this.isRestoreAndValue), 0)
            if(this.isRestoreAndValue){
                if(Object.keys(this.gameData.fsRestoreData.carsBeforeUpdate).find(v => v === carKey)){
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).multValue = (this.gameData as InitData).fsRestoreData.carsBeforeUpdate[carKey][0];
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).splitValue = (this.gameData as InitData).fsRestoreData.carsBeforeUpdate[carKey][1];
                }else{
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).multValue = 1;
                    RoadRage.bgOverlay.fetchBoxBytype(carKey).splitValue = 1;
                }
            }
        })

        this.timeline.to(this, { duration: duration * 1.125 });
    }

    getCarName(car: CarMoveInfo): string {
        switch (car.type) {
            case CarTypes.RED:
                return "Red: "
            case CarTypes.GREEN:
                return "Green: "
            default:
                return "Yellow: "
        }
    }

    driveCars(): void {
        if (this.carStopped.length) {
            this.carInfo = this.carInfo.filter(v => this.carStopped.indexOf(v.type) === -1);
            this.carStopped = [];
        }

        if(this.carInfo.length){
            this.carInfo.forEach((cI, i) => {
                const moveTL: gsap.core.Timeline = RoadRageEngineManager.getReel(cI.reel).getSymbol(cI.row)?.SetupMovement(this.stepDirection, cI.collides)!;
                this.carInfo[i].reelTo += this.stepDirection;
                this.carInfo[i].toCollect = true;
                moveTL.add(() => { RoadRageEngineManager.getReel(this.carInfo[i].reelTo).getSymbol(cI.rowTo)?.setupMark(cI.type,0.25)} )!
                this.timeline.add(moveTL, 0);
            });
            SoundManager.playSoundEffect(SoundConfig.CAR_MOVES_SETUP);
        }
    }

    trySwitchLane(): boolean {
        const carThatSwitches: CarMoveInfo = this.carInfo[this.carInfo.findIndex(c => 
            { return RoadRageEngineManager.getReel(c.reelTo).getSymbol(c.rowTo)?.symName === "F2"; }
        )];

        if (carThatSwitches) {
            this.switchLane(carThatSwitches);
            this.driveCollectSingel(carThatSwitches, this.timeline.duration()-0.15);
        }

        return !!carThatSwitches;
    }

    driveCollectSingel(car:CarMoveInfo,startTimer:number):void {
        // const carIndexToCollect: number = this.carInfo.findIndex(c => c.toCollect);
        // const carThatCollects: CarMoveInfo = this.carInfo[carIndexToCollect];
        const sym: RoadRageSpriteSymbol = RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)!;
        switch (sym.symName) {
            case "F5":
                this.BirdShit(car, sym.splitValue,startTimer);
                car.toCollect = false;
                break;
            case "F6":
                this.RoadSign(car, sym.splitValue, startTimer);
                car.toCollect = false;
                break;
            case "F7":
                this.RoadBump(car, sym.splitValue,startTimer);
                car.toCollect = false;
                break;
            default:
                break;
        }
    }

    driveCollect():void {
        const collectStart:number = this.timeline.duration();
        this.carInfo.forEach((c,i) => this.driveCollectSingel(c, collectStart + i* ( GameSetting.isFastSpin ? 0 : 0.4) ))
    }

    stopOrTurn(): void {

        if(this.carInfo.length){

            RoadRageEngineManager.getReel(this.carInfo[0].reelTo).AllWindowSymbols.forEach(s => {
                if(!s.gotMarked && !s.isCar){
                    s.changeState({state:"Disabled", forceState:true, duration:0.5})
                }
            })

            this.carInfo.forEach(c => {
                const sym: RoadRageSpriteSymbol = RoadRageEngineManager.getReel(c.reelTo).getSymbol(c.rowTo)!;
                this.featureTrigger(sym, c);
                c.toCollect = false;
            })
        }

        this.state.set(!this.carInfo.length ? SetupState.RESULT : SetupState.DRIVE);
    }

    featureTrigger(sym: RoadRageSpriteSymbol, car: CarMoveInfo): void {
        
        switch (sym.symName) {
            case "F1":
                // this.timeline.add(BonusCounters.instance.playMessage(car.type + " Stopped", 0.5, 0));
                this.Stop(car, true);
                break;
            case "F3":
                this.UTurn(car);
                return;
            default:
                break;
        }

        car.reelTo === this.endReel ? this.Stop(car, false) : false;

    }

    // F1: Stop : Stops The Car. // Kills it on the spot.
    Stop(car: CarMoveInfo, preStopped: boolean): boolean {

        this.carStopped.push(car.type);

        const symToStop: RoadRageSpriteSymbol = RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)!;
        const movesOut:boolean = car.reelTo === this.endReel;
        // symToStop.setPosID(car.rowTo);
        if(movesOut){
            if(!this.movedOutSound){
                this.movedOutSound = true;
                SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_LEAVES)
            }
            // const duration: number = 0.5;
            this.timeline.add(symToStop.carMovesOut(car.reelTo === 0 ,1),0)
            // this.timeline.to(this, { duration: duration * 1.125 },0);
        }else{
            symToStop.resetCarPos();
            RoadRageEngineManager.getReel(car.reelTo).addSymbolAbove(symToStop);
        }

        // if (preStopped) this.playMsg(car, "Stopped");

        return !this.carInfo.length;
    }

    // F2: SwitchLane if possible.
    switchLane(car: CarMoveInfo): void {
        // this.playMsg(car, "LaneSwitch");

        const carSym = RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)!;

        const dirrY: number = this.gameData.fsInfo.switchLane[car.reelTo] - car.rowTo;

        const startPos:number = this.timeline.duration() + 0.15;

        if(this.carInfo.findIndex(c => c.rowTo === this.gameData.fsInfo.switchLane[car.reelTo]) == -1){

            // const carEndPos = MathHelper.pointAdd(carSym.position, new PIXI.Point(0,symSize(this.gameData.Reel.reelModeHeight)*dirrY))

            this.timeline.add(carSym.moveSideWays(dirrY) , startPos);

            car.rowTo = this.gameData.fsInfo.switchLane[car.reelTo];
    
            this.timeline.add(() => { RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)?.setupMark(car.type,0.25) },startPos)!;

            this.timeline.to(this,{duration:0.55}, startPos);

            SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_SWITCH_LANE);
        }
        else {
            this.timeline.add(() => { RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)?.SwearSetup() }, startPos-0.25)
        }

        function symSize(height:number){
            return [144,126,108][height-3];
        }
    }

    // F3: U-Turn: Turn the car around for a new round.
    UTurn(car: CarMoveInfo): void {
        // this.playMsg(car, "Another Round!");

        const symToStop: RoadRageSpriteSymbol = RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)!;

        RoadRageEngineManager.getReel(this.startFromRight ? 0 : 4).isActive = false;

        symToStop.resetCarPos();
        symToStop.setPosID(car.rowTo);
        RoadRageEngineManager.getReel(car.reelTo).addSymbolAbove(symToStop,true);

        symToStop.putCarOnOverlay();
        symToStop.overlayCar.scale.x = this.startFromRight ? -1 : 1;
        this.carStopped.push(car.type)
    }

    // F5: BirdShit: +1 FS. - Count up on 
    BirdShit(car: CarMoveInfo, val: number,startpos:number): void {
        // this.playMsg(car, "+" + val + " FreeSpin");
        const plusTL:gsap.core.Timeline = RoadRage.overlayAnim.playPlusOneFS(RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)!, val,false);
        plusTL.add(() => { FsLeftBox.instance.addAmount(val); SoundManager.playSoundEffect(SoundConfig.PLUS_ONE_FREESPIN)},"-=0.7")
        
        plusTL.pause();
        this.timeline.add(() => { 
            this.birdCatcher.push(RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)?.playBird(val)!);
            SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_BIRD_HIT);
            plusTL.play();
        }, startpos)
    }

    // F6: RoadSign: +1 Mult on car. Apply on the Common area.
    RoadSign(car: CarMoveInfo, val: number,startpos:number): void {
        const bumpTL:gsap.core.Timeline = RoadRage.overlayAnim.playPlusBox(
            RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)!,
            RoadRage.bgOverlay.fetchBoxBytype(car.type),
            val,
            false,car.type);
        bumpTL.pause();
        // bumpTL.add(() => { RoadRage.bgOverlay.fetchBoxBytype(car.type).multValue += val; SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_PLUS_CAR)},startpos);
        this.timeline.add(() => { 
            RoadRage.bgOverlay.fetchBoxBytype(car.type).multValue += val; SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_PLUS_CAR)
            RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)?.MultSign(val)!;
            bumpTL.play();
         },startpos);
        // RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)?.SwearSetup();
    }

    // F7: RoadBump: Extra Split. Apply on common Area.
    RoadBump(car: CarMoveInfo, val: number,startpos:number): void {
        const splitTL:gsap.core.Timeline = RoadRage.overlayAnim.playPlusBox(
            RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)!,
            RoadRage.bgOverlay.fetchBoxBytype(car.type),
            val,
            true, car.type);
        splitTL.pause();
        // splitTL.add(() => { RoadRage.bgOverlay.fetchBoxBytype(car.type).splitValue += val; SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_PLUS_TIRE) },startpos);
        this.timeline.add(() => { 
            RoadRage.bgOverlay.fetchBoxBytype(car.type).splitValue += val; SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_PLUS_TIRE)
            RoadRageEngineManager.getReel(car.reelTo).getSymbol(car.rowTo)?.RoadBump(val)!;
            splitTL.play();
         },startpos);
        // RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)?.SwearSetup();
    }

    skip():void{

        super.skip();

        // this.carInfo.forEach(car => {
        //     RoadRageEngineManager.getReel(car.reel).getSymbol(car.row)!.skipped();
        // })

        if(this.birdCatcher.length){
            this.birdCatcher.forEach(b => b.totalProgress(1))
            this.birdCatcher = [];
        }
    }

    // private playMsg(car: CarMoveInfo, str: string): void {
    //     this.timeline.add(BonusCounters.instance.playMessage(this.getCarName(car) + str, 0.5, 0));
    // }

    done(): void { this.birdCatcher = [];}
}